import { createContext, useContext, useState } from 'react'
import { t } from './i18n'

const LangContext = createContext({})

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('stocko_lang') || 'fr')

  function changeLang(code) {
    setLang(code)
    localStorage.setItem('stocko_lang', code)
  }

  return (
    <LangContext.Provider value={{ lang, changeLang, t: (key) => t(lang, key) }}>
      {children}
    </LangContext.Provider>
  )
}

export const useLang = () => useContext(LangContext)
